import { Component, Input } from '@angular/core';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { IBaryInput } from 'models/bary-input';
import { CommonModule } from '@angular/common';
import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-bary-input-phone',
  templateUrl: './bary-input-phone.component.html',
  styleUrls: ['./bary-input-phone.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputUtilitiesModule, InputsModule, MDBBootstrapModulesPro, MarkAsteriskDirective, TranslateDirective, BaryIconComponent],
})
export class BaryInputPhoneComponent implements IBaryInput {
  @Input() id: string = BaryComponentHelper.makeId();
  @Input() label?: string;
  @Input() icon?: string;
  @Input() name?: string;
  @Input() disabled: boolean = false;

  @Input() control = new FormControl('');

  protected readonly FAR = FaDirectiveEnum.FAR;

  public keyPress($event: KeyboardEvent): void {
    const pattern = /[0-9+\- ]/;
    const inputChar = $event.key;
    if ($event.key !== '+' && !pattern.test(inputChar)) {
      $event.preventDefault();
    }
  }
}
